<!--  -->
<template>
    <div class="gardenList padding-20 bgc box-shadow">
        <div class="btn_search">
            <div class="left_btn">
                <el-button type="primary" @click="addGarden" class="addGarden">新增园区</el-button>
                <el-button type="primary" class="register_msg" @click="goRegisterMessage">登记信息</el-button>
            </div>
            <div class="right_search">
                <el-select v-model="params.status" placeholder="选择状态">
                    <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.code"></el-option>
                </el-select>
                <el-select v-model="params.isrecommend" placeholder="是否推荐">
                    <el-option v-for="(item, index) in recommend" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select v-model="params.provinceid" placeholder="所在省份" @change="provinceidChange">
                    <el-option v-for="(item, index) in provinceList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select v-model="params.cityid" no-data-text="请选择省份" placeholder="所在城市">
                    <el-option v-for="(item, index) in cityList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input v-model="params.name" class="garden_name" placeholder="请输入园区名称"></el-input>
                <el-button @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="园区名称" width="382px" class-name="center">
                <template slot-scope="scope">
                    <div class="img_name">
                        <div class="left_img">
                            <img :src="scope.row.coverurl" alt="">
                        </div>
                        <div class="right_name">{{scope.row.name}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="所在地区" width="130px" class-name="center"></el-table-column>
            <el-table-column prop="parklevelname" label="园区级别" width="80px" class-name="center"></el-table-column>
            <el-table-column prop="isrecommendname" label="是否推荐" width="80px" class-name="center"></el-table-column>
            <!-- <el-table-column prop="officialtel" label="联系电话" width="130px" class-name="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.officialtel">{{scope.row.officialtel}}</span>
                    <span v-else>--</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="viewcount" label="浏览量" width="100px" class-name="center"></el-table-column>
            <el-table-column prop="statusname" label="发布状态" width="100px" class-name="center">
                <template slot-scope="scope">
                    <span :class="scope.row.status | filterStatus">{{scope.row.statusname}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="lastupdatetime" label="最后更新时间" width="136px" class-name="center"></el-table-column>
            <el-table-column prop="date" label="操作" class-name="right">
                <template slot-scope="scope">
                    <span class="handle" @click="handleEdit(scope.row, scope.$index)">编辑</span>
                    <span class="line" v-if="scope.row.status === 10 || scope.row.status === 0">|</span>
                    <span class="handle" @click="handleDelete(scope.row, scope.$index)" v-if="scope.row.status === 10 || scope.row.status === 0">删除</span>
                    <span class="line">|</span>
                    <span class="handle" @click="handleRecommend(scope.row, scope.$index)" v-if="scope.row.isrecommend === '0'">设为推荐</span>
                    <span class="handle" @click="handleRecommend(scope.row, scope.$index)" v-if="scope.row.isrecommend === '1'">取消推荐</span>
                    <span class="line">|</span>
                    <span class="handle" @click="handleContentManage(scope.row)">内容管理</span>
                </template>
            </el-table-column>
        </el-table>
        <Page ref="page" :total="total" @getList="getList" />
    </div>
</template>

<script>
import citys from 'common/js/citys.json'
import {mapActions, mapGetters} from 'vuex'
import {getAllGovparksinfo, uploadGovparksStatus, uploadGovparksIsrecommend} from 'api/gardenApi'
import Page from 'base/page/page'
export default {
    data() {
        return {
            statusList: [
                {code: ' ', name: '全部状态'},
                {code: 0, name: '草稿'},
                {code: 10, name: '已发布'},
                {code: 100, name: '已删除'}
            ],
            recommend: [
                {value: ' ', label: '全部'},
                {value: 1, label: '推荐'},
                {value: 0, label: '不推荐'}
            ],
            provinceList: [],
            cityList: [],
            params: {
                status: '',
                isrecommend: '',
                provinceid: '',
                cityid: '',
                name: ''
            },
            tableData: [],
            total: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.provinceList.push({label: '全部省份', value: ' '})
        citys.forEach((obj, index) => {
            let item = {
                label: obj.label,
                value: obj.value
            }
            this.provinceList.push(item)
        })
        this.getList()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        goRegisterMessage() {
            this.$router.push({name: 'RegisterMessage'})
        },
        provinceidChange(provinceid) {
            if (provinceid && provinceid !== ' ') {
                citys.some((obj, index) => {
                    if (obj.value === provinceid) {
                        this.cityList = obj.children
                        this.cityList.unshift({label: '全部城市', value: ' '})
                        return true
                    }
                })
            } else {
                this.params.cityid = ''
                this.cityList = []
            }
        },
        handleSearch() {
            this.setPage({page: 1, pageSize: 10})
            this.getList()
        },
        getList() {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.isrecommend === ' ') {
                params.isrecommend = ''
            }
            if (params.status === ' ') {
                params.status = ''
            }
            getAllGovparksinfo({
                data: Object.assign({}, params, this.page),
                success: res => {
                    this.setLoading(false)
                    this.tableData = res.data.content
                    this.total = res.data.pageinfo.rowCount
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 编辑
        handleEdit(row, index) {
            this.$router.push({name: 'GardenEdit', query: {innerid: row.innerid}})
        },
        // 删除
        handleDelete(row, index) {
            this.$confirm('确定删除该园区吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                uploadGovparksStatus({
                    data: {innerid: row.innerid},
                    success: res => {
                        this.setLoading(false)
                        row.status = 100
                        row.statusname = '已删除'
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
            })
        },
        // 推荐
        handleRecommend(row, index) {
            this.setLoading(true)
            let isrecommend = 0
            if (row.isrecommend === '0') {
                isrecommend = 1
            } else {
                isrecommend = 0
            }
            uploadGovparksIsrecommend({
                data: {innerid: row.innerid, isrecommend},
                success: res => {
                    this.setLoading(false)
                    if (isrecommend) {
                        row.isrecommend = '1'
                        row.isrecommendname = '是'
                    } else {
                        row.isrecommend = '0'
                        row.isrecommendname = '否'
                    }
                },
                errro: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 内容管理
        handleContentManage(row) {
            this.setPage({page: 1, pageSize: 10})
            this.$router.push({
                name: 'GardenContentList',
                query: {
                    parkinnerid: row.innerid,
                    name: row.name
                }
            })
        },
        // 新增园区
        addGarden() {
            this.$router.push({
                name: 'GardenEdit'
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {
        filterStatus(status) {
            let classname = ''
            switch(status) {
                case 0:
                    classname = 'status0'
                break
                case 10:
                    classname = 'status10'
                break
                case 100:
                    classname = 'status100'
                break
            }
            return classname
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .gardenList {
        .btn_search {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left_btn {
                .addGarden {
                    margin-right: 30px;
                    margin-bottom: 30px;
                }
                .register_msg {
                    margin: 0;
                }
            }
            .right_search {
                display: flex;
                align-items: center;
                margin-bottom: 30px;
                .el-select {
                    min-width: 108px;
                    width: 108px;
                    margin-right: 20px;
                    .el-select__caret {
                        line-height: 32px;
                    }
                }
                .garden_name {
                    width: 150px;
                }
                .el-button {
                    margin-left: 30px;
                    width: 95px;
                }
            }
        }
        .el-table {
            .center {
                .cell {
                    text-align: center;
                }
            }
            .right {
                .cell {
                    text-align: right;
                }
            }
            .img_name {
                display: flex;
                .left_img {
                    width: 106px;
                    height: 60px;
                    margin-right: 10px;
                    img {
                        width: 106px;
                        height: 60px;
                    }
                }
                .right_name {
                    font-size: 14px;
                    text-align: left;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 18px;
                }
            }
            .status0 {
                color: #606266;
            }
            .status10 {
                color: #67C23A;
            }
            .status100 {
                color: #999999;
            }
            .handle {
                font-size: 14px;
                cursor: pointer;
                color: #439FFE;
            }
            .line {
                font-size: 14px;
                color: #439FFE;
                margin: 0 5px;
                position: relative;
                top: -1px
            }
        }
    }
</style>